import React from 'react'

export default () => (
  <svg className="o2-footer" id="Group_291" data-name="Group 291" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27.891 27.444">
    <path id="Path_397" data-name="Path 397" d="M0,11.3c0,6.177,4.486,11.3,11,11.3,6.476,0,10.962-5.126,10.962-11.3C21.966,4.738,17.568,0,11,0,4.4,0,0,4.738,0,11.3Zm4.234,0c0-4.1,2.5-8.085,6.77-8.085,4.234,0,6.729,3.981,6.729,8.085,0,3.852-2.073,8.085-6.729,8.085-4.7,0-6.77-4.234-6.77-8.085Z" />
    <path id="Path_398" data-name="Path 398" d="M373.153,311.523v-1.509h-3.9c1.562-1.533,3.6-3.394,3.6-5.42,0-1.879-1.18-2.795-3-2.795a6.333,6.333,0,0,0-2.836.687l.153,1.591a4.15,4.15,0,0,1,2.208-.769c.781,0,1.562.411,1.562,1.286,0,1.75-3.247,4.462-4.134,5.326v1.6Z" transform="translate(-345.263 -284.079)" />
  </svg>
)



// WEBPACK FOOTER //
// ./src/components/Static/logos/o2-footer.js